import { css, html, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "./base/BaseElement";
import("../ui/RotatePane");

@customElement("float-menu")
export class FloatMenu extends BaseElement {
  static styles = css`
    float-menu {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      box-shadow: 0 2px 8px #0000001f;
      border-radius: 2rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      z-index: 10;
    }

    float-menu .svg {
      width: 20.5px;
      height: 20.5px;
      background-color: #f7f7f7e6;
    }

    float-menu .button {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f7f7f7e6;
    }

    float-menu .button:active {
      fill: #ff0000;
    }

    float-menu .button:hover {
      background-color: #ffffff;
    }
  `;

  private _rotateOn = "false";
  private _rotation? = "false";
  private _replace? = "true";
  private _delete? = "true";

  private _handleRotateOn() {
    this._rotateOn = "true";
    this.requestUpdate();
  }

  private _handleRotateEnd(e: any) {
    const rotateEvent = new CustomEvent("rotate-end", {
      ...e,
      bubbles: true,
      composed: true,
      detail: e.detail,
    });
    this.dispatchEvent(rotateEvent);
  }

  private _handleRotateChange(e: any) {
    const rotateEvent = new CustomEvent("rotate-change", {
      ...e,
      bubbles: true,
      composed: true,
      detail: e.detail,
    });
    this.dispatchEvent(rotateEvent);
  }

  private _handleDeleteModel(e: any) {
    this.dispatchEvent(new CustomEvent("delete", e));
  }

  private _handleReplaceModel(e: any) {
    this.dispatchEvent(new CustomEvent("replace", e));
  }

  connectedCallback(): void {
    super.connectedCallback();
    this._rotation = this.getAttribute("rotation") || undefined;
    this._delete = this.getAttribute("delete") || undefined;
    this._replace = this.getAttribute("replace") || undefined;
    this.requestUpdate();
  }

  protected renderHtml(): TemplateResult {
    return html` ${this._rotateOn === "true"
      ? html`<rotate-pane
          @end=${this._handleRotateEnd}
          @change=${this._handleRotateChange}
        ></rotate-pane>`
      : html`${this._rotation === "true"
          ? html`<div class="button" @click=${this._handleRotateOn}>
              <svg class="svg" data-v-a281fab8-s="">
                <use xlink:href="#icon-rotate2"></use>
              </svg>
            </div>`
          : ``}
        ${this._delete === "true"
          ? html`<div class="button" @click=${this._handleDeleteModel}>
              <svg class="svg container-svg" data-v-a281fab8-s="">
                <use xlink:href="#icon-delete"></use>
              </svg>
            </div> `
          : ``}
        ${this._replace === "true"
          ? html`<div class="button" @click=${this._handleReplaceModel}>
              <svg class="svg container-svg" data-v-a281fab8-s="">
                <use xlink:href="#icon-change_product"></use>
              </svg>
            </div>`
          : ``} `}`;
  }
}
